import { Cache } from "memory-cache";
import { PlanetEntity } from ".";
import { Client } from "../service/esiclient";
import { HandleEsiError } from "../helpers/ErrorDisplayHelper";

// ESI client
const esiClient = new Client();
// Cache
const cache = new Cache();

export async function getCachedPlanetEntity(planet_id: number): Promise<PlanetEntity | null> {
  let entity: any = await cache.get(planet_id.toString());
  if (entity) {
    return entity;
  }
  try {
    const planet = await esiClient.get_universe_planets_planet_id(null, null, planet_id);
    if (planet !== null) {
      entity = new PlanetEntity(planet_id, planet);
      cache.put(planet_id.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
      return entity;
    } else {
      return null;
    }
  } catch (error) {
    HandleEsiError(error, undefined, "planet");
    return null;
  }
}
